import { ProjectNote } from "../types";

export const sortProjectNotesByCreatedAt = (a: ProjectNote, b: ProjectNote) => {
  if (a.createdAt === b.createdAt) {
    return a.id > b.id ? 1 : -1;
  }
  return a.createdAt > b.createdAt ? 1 : -1;
};
